import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import rootReducer from './reducers'
import { persistStore, persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const initalState = {

}

const middleware = [thunk]

const store = createStore(persistedReducer, initalState, composeWithDevTools(applyMiddleware(...middleware)))

const persistor = persistStore(store);
export {persistor}
export default store;